import {
  Box,
  Button,
  Flex,
  Icon,
  IconButton,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FaAngleDown, FaAngleUp, FaClock, FaRobot } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import AiResults from "./AiResults";
import Format from "string-format";
import { handleHTTPError } from "../_actions/errorHandlerActions";
import { newAiresults, prependAiResults } from "../_actions/aiDocumentActions";
import axios from "axios";
import {
  MAGIC_DESIGN,
  MAGIC_ENDPOINT,
  SAVED_COPIES,
} from "../_actions/endpoints";
import { analyticsTrackEvent, checkCeleryTaskStatus } from "../_utils/common";
import { useTranslation } from "react-i18next";
import { showToast } from "../_utils/showToast";
import { STORY_DETAIL } from "../_utils/routes";
import { FeatureCodes } from "../_components/details/constants";
import connectedFeatureAvailabilityWrapper from "../_components/common/withFeatureAvailability";
import { openUrl } from "@simplified-workspace/shared/util";
import TldrUpgradeSubscriptionModal from "../_components/common/modals/TldrUpgradeSubscriptionModal";
import { aiIncludedFeatures } from "../_utils/constants";
import aiLongFormArtBoard from "../assets/images/aiLongFormArtBoard.jpeg";
import { isEmpty } from "lodash";

const AiHistory = ({ handleDocumentAddNow, ...props }) => {
  const data = useSelector((state) => state.document.data);
  const airesults = useSelector((state) => state.airesults);
  const [selected, setSelectedResults] = useState({});
  const [submit, isSubmitting] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isFeatureLockModalOpen, setIsFeatureLockModalOpen] = useState(false);
  const { t } = useTranslation(["ai", "common"]);
  const dispatch = useDispatch();
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [collapseResults, setCollapseResult] = useState(true);
  const [historyResults, setHistoryResults] = useState([]);

  let signalToken = axios.CancelToken.source();
  useEffect(() => {
    if (data.id) {
      fetchSavedResults();
    }
    return () => {
      signalToken.cancel("The user aborted a request.");
    };
  }, []);

  function fetchSavedResults() {
    isSubmitting(true);
    axios
      .get(Format(`${SAVED_COPIES}?document=${data.id}&page=${1}`))
      .then((res) => {
        if (airesults.newPayload.length !== res.data.results.length) {
          setHistoryResults(res.data.results);
        }
        isSubmitting(false);
      })
      .catch((error) => {
        isSubmitting(false);
        dispatch(handleHTTPError(error, props));
      });
  }

  const loadMoreData = () => {
    fetchSavedResults(airesults.page);
  };

  function generateContent() {
    isSubmitting(true);
    axios
      .post(Format(MAGIC_ENDPOINT, data.id))
      .then((res) => {
        checkCeleryTaskStatus(res.data.task_id, () => {})
          .then((res) => {
            isSubmitting(false);
            if (Array.isArray(res.response.info)) {
              dispatch(prependAiResults(res.response.info));
            } else if (res.response.info?.error) {
              showToast({
                description: res.response.info?.error,
                title: t("try_again"),
                status: "error",
              });
            }
          })
          .catch((error) => {
            if (error) {
              dispatch(handleHTTPError(error, props));
            }
          });
      })
      .catch((error) => {
        if (error.response.status === 429) {
          setIsFeatureLockModalOpen(true);
        }
        isSubmitting(false);
        dispatch(handleHTTPError(error, props));
      });
  }

  function generateDesign() {
    analyticsTrackEvent("generateDesign");
    setIsGenerating(true);
    const values = { copies: Object.values(selected) };
    axios
      .post(Format(MAGIC_DESIGN, data.id), values)
      .then((res) => {
        checkCeleryTaskStatus(res.data.task_id, () => {})
          .then((res) => {
            setIsGenerating(false);
            if (Array.isArray(res.response.info)) {
              dispatch(prependAiResults(res.response.info));
            } else if (res.response.info?.error) {
              showToast({
                description: res.response.info?.error,
                title: t("try_again"),
                status: "error",
              });
            } else {
              const editStoryUrl = Format(
                STORY_DETAIL,
                res.response.info.organization,
                res.response.info.id,
                encodeURIComponent(res.response.info.title)
              );
              openUrl(encodeURI(editStoryUrl), "_blank");
            }
          })
          .catch((error) => {
            if (error) {
              dispatch(handleHTTPError(error, props));
            }
          });
      })
      .catch((error) => {
        setIsGenerating(false);
        dispatch(handleHTTPError(error, props));
      });
  }

  const updateSelected = (val) => {
    setSelectedResults(val);
  };

  function deleteRow(resultId) {
    let history = historyResults.filter(function (result) {
      return result.id !== resultId;
    });
    setHistoryResults(history);
    let newResults = airesults?.newPayload.filter(function (result) {
      return result.id !== resultId;
    });
    dispatch(newAiresults(newResults));
  }

  function onStateUpdate(state, result) {
    const historyIndex = historyResults.findIndex((airesult) => {
      return airesult.id === result.id;
    });

    let resultIndex = airesults?.newPayload.findIndex(function (newResult) {
      return newResult.id === result.id;
    });

    let historyData = historyResults;
    let newResultData = airesults?.newPayload;
    if (state === "flagged") {
      if (historyIndex > -1) {
        historyData?.splice(resultIndex, 1);
      }
      if (resultIndex > -1) {
        newResultData?.splice(historyIndex, 1);
      }
    } else {
      if (historyIndex > -1) {
        historyData[historyIndex] = result;
      }
      if (resultIndex > -1) {
        newResultData[resultIndex] = result;
      }
    }
    dispatch(newAiresults(newResultData));
  }
  const showTabsResultPanel = () => {
    return (
      <>
        <Box
          id="template-tab"
          d={"flex"}
          flexDirection={"column"}
          flexGrow={1}
          mt={4}
          minH="295px"
        >
          <Tabs
            defaultIndex={0}
            variant={"panel"}
            isFitted={props.fitted || isMobileView}
            isLazy
          >
            <TabList>
              <Tab px={8}>
                <Icon as={FaRobot} mr={2} /> {t("result")}
              </Tab>
              <Tab px={8}>
                <Icon as={FaClock} mr={2} /> {t("history_label")}
              </Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <AiResults
                  templateType={data?.prompt?.template}
                  type={props.type}
                  handleDocumentAddNow={(result) =>
                    handleDocumentAddNow(result)
                  }
                  onDelete={deleteRow}
                  onStateUpdate={onStateUpdate}
                  airesults={airesults.newPayload}
                  hasmore={false}
                  page={1}
                  loadMoreData={loadMoreData}
                  noDataTitle={t("no_results_found")}
                  selectedResults={(val) => updateSelected(val)}
                  isFeatureLockModalOpen={isFeatureLockModalOpen}
                ></AiResults>
              </TabPanel>
              <TabPanel>
                <AiResults
                  templateType={data?.prompt?.template}
                  type={props.type}
                  handleDocumentAddNow={(result) =>
                    handleDocumentAddNow(result)
                  }
                  onDelete={deleteRow}
                  onStateUpdate={onStateUpdate}
                  hasmore={airesults.hasmore}
                  page={airesults.page}
                  airesults={historyResults}
                  loadMoreData={loadMoreData}
                  noDataTitle={t("no_history_found")}
                  selectedResults={(val) => updateSelected(val)}
                  isFeatureLockModalOpen={isFeatureLockModalOpen}
                ></AiResults>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </>
    );
  };
  return (
    <>
      {props.type === "normal" && (
        <Flex
          justify="space-between"
          align="center"
          direction={["column", "column", "row", "row"]}
        >
          <Flex justify="space-between">
            <Flex basis="0" grow="2" direction="column">
              <Flex
                justify="start"
                textAlign="center"
                align="center"
                fontSize="1.25rem"
                fontWeight="500"
              >
                {t("result")}
              </Flex>
              <Text
                fontSize={isMobileView ? "0.875rem" : "1rem"}
                color="gray.300"
              >
                {t("generate_more_text")}
              </Text>
            </Flex>
            {isMobileView &&
              (collapseResults ? (
                <IconButton
                  icon={<FaAngleUp />}
                  variant="unstyled"
                  onClick={() => setCollapseResult(false)}
                />
              ) : (
                <IconButton
                  icon={<FaAngleDown />}
                  variant="unstyled"
                  onClick={() => setCollapseResult(true)}
                />
              ))}
          </Flex>

          <Flex
            w="full"
            align={["flex-start", "flex-start", "flex-end", "flex-end"]}
            basis="0"
            grow="1"
            direction="column"
          >
            <Flex pt="1" align="center">
              {data?.prompt?.template === "image" && (
                <Flex align={["flex-start", "flex-end", "flex-end"]}>
                  <Flex
                    pt="0"
                    direction="column"
                    align={["flex-start", "flex-end", "flex-end"]}
                  >
                    <Button
                      variant={
                        Object.entries(selected).length > 0
                          ? "solid"
                          : "secondary"
                      }
                      disabled={Object.entries(selected).length === 0}
                      onClick={generateDesign}
                      isLoading={isGenerating}
                      loadingText={t("preparing_creatives")}
                      size="sm"
                    >
                      {t("generate_creatives")}
                    </Button>
                  </Flex>
                </Flex>
              )}
            </Flex>
          </Flex>
        </Flex>
      )}
      {isMobileView && collapseResults ? showTabsResultPanel() : ""}
      {!isMobileView && showTabsResultPanel()}

      {isFeatureLockModalOpen ? (
        <TldrUpgradeSubscriptionModal
          show={isFeatureLockModalOpen}
          onHide={() => setIsFeatureLockModalOpen(false)}
          featureList={aiIncludedFeatures}
          image={aiLongFormArtBoard}
          title={t("ai_feature_heading", { ns: "ai" })}
        />
      ) : null}
    </>
  );
};

export default connectedFeatureAvailabilityWrapper(AiHistory);
